import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress
} from '@mui/material';

const DeleteSourceConfirmDialog = ({ open, source, onConfirm, onCancel, isDeleting = false }) => {
    return (
        <Dialog open={open} onClose={onCancel}>
            <DialogTitle>Xóa nguồn dữ liệu?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Bạn có chắc muốn xóa nguồn &quot;{source?.name}&quot;? Cấu hình kết nối sẽ bị xóa và không thể khôi phục.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={isDeleting}>Hủy</Button>
                <Button onClick={onConfirm} color="error" variant="contained" disabled={isDeleting} startIcon={isDeleting ? <CircularProgress size={16} color="inherit" /> : null}>
                    {isDeleting ? 'Đang xóa...' : 'Xóa'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteSourceConfirmDialog;
